import { BUSINESS_PLAN_TYPES } from 'constants/businessPlan';

import { IBusinessPlanType } from 'interfaces/businessPlan';

export const getDocumentType = (template: IBusinessPlanType): IBusinessPlanType => {
  if (template === BUSINESS_PLAN_TYPES.ONE_PAGE_SHORT) return BUSINESS_PLAN_TYPES.ONE_PAGE;

  return template;
};
